import vue from "../main";

export default function() {
  return [
    { id: 1, name: vue.$t("$staticData.paymentTypes.cash") },
    { id: 2, name: vue.$t("$staticData.paymentTypes.transfer") }
  ].sort((a, b) => (a.name > b.name ? 1 : -1));
}
